<template>
  <v-card class="metrics-main-info">
    <v-card-title class="pa-0">
      Podstawowe informacje
    </v-card-title>
    <v-row>
      <v-col
        v-if="project.name"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">Nazwa projektu:</label>
        <v-text-field
          :value="project.name"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
      <v-col
        v-if="project.id"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">ID projektu:</label>
        <v-text-field
          :value="project.id"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
      <v-col
        v-if="project.status"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">Status projektu:</label>
        <v-text-field
          :value="project.status"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
      <v-col
        v-if="project.projectType"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">Typ projektu:</label>
        <v-text-field
          :value="project.projectType"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
      <v-col
        v-if="project.media"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">Media:</label>
        <v-text-field
          :value="mediaValue"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
      <v-col
        v-if="project.createdAt"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">Termin rozpoczęcia:</label>
        <v-text-field
          :value="project.createdAt | displayDate"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
      <v-col
        v-if="project.endDate"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">Termin zakończenia:</label>
        <v-text-field
          :value="project.endDate | displayDate"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
      <v-col
        v-if="project.deadline"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">Termin wykonania:</label>
        <v-text-field
          :value="project.deadline | displayDate"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
      <v-col
        v-if="project.discLocation"
        cols="6"
        md="4"
        lg="3"
      >
        <label class="input-label">Lokalizacja projektu:</label>
        <v-text-field
          :value="project.discLocation"
          v-bind="props.disabledInput"
          class="project-main-info__input"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import props from '@/helpers/componentsProps';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      props,
    };
  },
  computed: {
    mediaValue() {
      return this.project.media
        ?.map((media) => media.name)
        ?.join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-main-info {
  width:100%;
  padding: 24px 32px 40px;
  margin:16px 0;
  &__input {
    background: $bg-light;
  }
  &::v-deep .v-input__slot input {
    font-weight: 500;
  }
}
</style>
